// @flow

import React from "react";
import { get, noop } from "lodash";
import type { NullaryFn } from "@tvg/types/Functional";
import Icon from "@fdr/static-ui/Icons";
import { add } from "@fdr/static-ui/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";
import {
  Container,
  ColumnCell,
  Label,
  IconContainer,
  AddFundsWrapper
} from "./styled-components";
import Button from "../../_atoms/Button";

type Props = {
  url?: string,
  onClick?: NullaryFn<mixed>,
  label?: string
};

export const AddFundsButton = ({
  url = "/",
  onClick = noop,
  label = "Add funds"
}: Props) => {
  return (
    <AddFundsWrapper>
      <Button
        type="link"
        url={url}
        isInternalLink
        onClick={onClick}
        qaLabel="addFundsButton"
      >
        <Container>
          <ColumnCell>
            <Label data-qa-label="addFundsButtonLabel">{label}</Label>
          </ColumnCell>
          <ColumnCell>
            <IconContainer>
              <Icon icon={add} size={24} color={buildColor("navy")} />
            </IconContainer>
          </ColumnCell>
        </Container>
      </Button>
    </AddFundsWrapper>
  );
};

export default AddFundsButton;
